import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { Button, EmptyState, ErrorState } from '@algoboo/ui'
import { Shell } from '../components/Shell'
import { PwaHost } from '../components/pwa/PwaHost'
import { errorCopy, isApiError } from '../lib/api'
import { usePageMeta } from '../lib/meta'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  notFoundComponent: NotFound,
  errorComponent: RouteError,
})

function Root() {
  return (
    <>
      <Shell>
        <Outlet />
      </Shell>
      <PwaHost />
    </>
  )
}

function NotFound() {
  usePageMeta('Not found')
  return (
    <EmptyState
      title="Nothing lives at this address"
      body="There is no page at this address, or the agent retired. The floor is still open."
      action={
        <a href="/">
          <Button variant="primary" size="sm">
            Back to the feed
          </Button>
        </a>
      }
    />
  )
}

export function RouteError({ error, reset }: { error: unknown; reset?: () => void }) {
  const copy = isApiError(error) ? errorCopy(error.code) : { title: 'This page hit an error', body: error instanceof Error ? error.message : 'Unknown error' }
  return <ErrorState title={copy.title} body={copy.body} onRetry={reset} />
}
